import {
  BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD,
  StateManager,
  useBCMSContext,
  useParams,
  useRoute,
  useStateManager, useWorkflow
} from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UIRadio from "components/ui/UIRadio";
import Classes, { Transaction } from "model";
import React from "react";
import "./styles.css";

/**
 * @function DisputeTransactionView
 * @param {STRING} merchantDescription - The description of which merchant made the transaction. 
 * @param {DECIMAL} disputeAmount - The amount of the transaction. 
 * @param {STRING} transactionDate - The date the transaction was made. 
 * @return {React.Component}
 * @exported true
 * @description This is the view for the first step of the workflow. 
 * @example
 * <DisputeTransactionView merchantDescription="Description" disputeAmount="00.00" transactionDate="XX/XX/XXXX"/>
 */
export default function DisputeTransactionView(props) {
  const bcmsContext = useBCMSContext();
  // Global controller used to cause a refresh of the page when the account details modal
  // updates the account name
  const globalContext = useBCMSContext();

  //const globalController = useBCMSContext();
  //BCMSRecord.globalControllerFor([ Transaction ], globalController);
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const navigate = useRoute();
  /*const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const workflowStepState = workflowStep.getStepState;
  const [ state, setState ] = useState({...workflowStepState});
  const navigate = useRoute();

  const merchantDescription = state.transaction.merchant.description ?? "[merchantDescription]";
  const disputeAmount = state.transaction.amount.format() ?? "[disputeAmount]";
  const transactionDate = state.transaction.purchaseDate.format('M d, Y') ?? "[transactionDate]";*/

  const { goStep, nextStep, prevStep, state } = useWorkflow() ?? {};
  const paramsTransactionID = useParams().transactionID ?? "0";
  const data = { ...getDefaultData(paramsTransactionID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    forceUpdate: (data, ui) => {
      BCMSStateManagerCRUD.init(state)
        .update([ "data" ], data)
        .update([ "ui" ], ui)
        .submit(setState);
    },

    change: (val, label) => {
      const crud = BCMSStateManagerCRUD.init(state);
      if(label === "Yes, but I need to dispute the transaction.") {
        //setState({...state, didUserMakeThisTransaction: true});
        crud
        .update([ "data", "dispute", "didYouMakeThisTransaction" ], "yes")
        .update([ "ui" ], ui)
        .submit(setState);
      } else {
        //setState({...state, didUserMakeThisTransaction: false});
        crud
        .update([ "data", "dispute", "didYouMakeThisTransaction" ], "no")
        .update([ "ui" ], ui)
        .submit(setState);
      }
    },

    next: () => {
      //workflowStep.update(["didUserMakeThisTransaction"], state.didUserMakeThisTransaction);
  
      if(data.dispute.didYouMakeThisTransaction === "yes") {
        goStep(1, { data, ui })
        //workflowStep.workflow.goStep(2, {...workflowStepState});
      } else {
        goStep(8, { data, ui })
        //workflowStep.workflow.nextStep();
      }
    },

    cancel: evt => {
      navigate(-1);
    }
  });

  /*const change = (val, label) => {
    if(label === "Yes, but I need to dispute the transaction.") {
      setState({...state, didUserMakeThisTransaction: true});
    } else {
      setState({...state, didUserMakeThisTransaction: false});
    }
  }

  const next = evt => {
    workflowStep.update(["didUserMakeThisTransaction"], state.didUserMakeThisTransaction);

    if(state.didUserMakeThisTransaction) {
      workflowStep.workflow.goStep(2, {...workflowStepState});
    } else {
      workflowStep.workflow.nextStep();
    }
  }

  const cancel = evt => {
    navigate(-1);
  }*/

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = transactionID => {
  const transaction = Transaction.initByID(transactionID);
  const dispute = BCMSDefaultModel.transactionDispute();
  dispute.transaction = transaction;

  return {
    dispute
      /*transaction: transaction,
      didUserMakeThisTransaction: true,
      disputeReason: "",
      disputeReasonAdditionalComments: "",
      confirmationNumber: "42101123000",
      disputeSubmissionDate: BCMSDate.init()*/
  }
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, change, next, cancel } = useStateManager();
  const dispute = data.dispute ?? {};
  const transaction = dispute.transaction ?? {};
  const merchantDescription = transaction.merchant.description ?? "[merchantDescription]";
  const disputeAmount = transaction.amount.format() ?? "[disputeAmount]";
  const transactionDate = transaction.purchaseDate.format('M d, Y') ?? "[transactionDate]";
  const yesDataPoint = { dataPoint: "Selection_Yes" };
  const noDataPoint = { dataPoint: "Selection_No" };
  const nextButtonDataPoint = { dataPoint: "Next_Button_No" };

  return (
    <>
      <FormContainer className="dispute-transaction-view">
        <FormRow>
          <p className="form-label">Tell us if this is a transaction you recognize.</p>
        </FormRow>
        {/* Use the hide class to show or hide the text */}
        <p className="hide">Select the reason you are disputing this transaction. Feel free to include additional comments to give us more context.</p>
        <div className="transaction-details">
          <FormRow>
            <p>Merchant Description</p>
            <p className="gray-text">{ merchantDescription }</p>
          </FormRow>
          <FormRow>
            <p>Transaction Amount</p>
            <p className="gray-text">{ disputeAmount }</p>
          </FormRow>
          <FormRow>
            <p>Transaction Date</p>
            <p className="gray-text">{ transactionDate }</p>
          </FormRow>
        </div>
        <FormRow>
          <p className="form-label">Did you make this transaction? *</p>
        </FormRow>
        <FormRow className="radio-container">
          <UIRadio label="Yes, but I need to dispute the transaction." { ...yesDataPoint } value={ dispute.didYouMakeThisTransaction === "yes" } onChange={ change } />
        </FormRow>
        <FormRow>
          <UIRadio label="No, I don't recognize the transaction." { ...noDataPoint } value={ dispute.didYouMakeThisTransaction === "no" } onChange={ change } />
        </FormRow>
        <FormButtonContainer>
          <UIPrimaryButton text="Next" { ...nextButtonDataPoint } className={ dispute.didYouMakeThisTransaction === undefined ? "disabled" : ""} onClick={ next }/>
          <UICancelButton text="Cancel" onClick={ cancel } />
        </FormButtonContainer>
      </FormContainer>
    </>
  )
}
